export default "/logo.svg"